import React from 'react';
import { Box, Button } from '@mui/material';

import { useStyles } from './styles';
import { CustomSpotsEditorController } from './useCustomSpotsEditor';

type EditorFooterProps = {
  classes: ReturnType<typeof useStyles>;
  controller: CustomSpotsEditorController;
};

export const EditorFooter: React.FC<EditorFooterProps> = ({
  classes,
  controller,
}) => {
  const {
    t,
    isVideoSpot,
    hasPreview,
    isBusy,
    isImageReadyToUpload,
    isVideoReadyToSubmit,
    handleConfirm,
    handleClose,
    handleLoadAnother,
  } = controller;

  if (isVideoSpot) {
    return (
      <Box sx={classes.footerButtons}>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!isVideoReadyToSubmit}
          sx={classes.primaryButton}
        >
          {t('customSpotsEditor.loadToWorld')}
        </Button>
        <Button
          variant="outlined"
          onClick={handleClose}
          disabled={isBusy}
          sx={classes.tertiaryButton}
        >
          {t('common.cancel')}
        </Button>
      </Box>
    );
  }

  if (!hasPreview) {
    return (
      <Button
        variant="outlined"
        onClick={handleClose}
        disabled={isBusy}
        sx={classes.footerSingleButton}
      >
        {t('common.cancel')}
      </Button>
    );
  }

  return (
    <Box sx={classes.footerButtons}>
      <Button
        variant="contained"
        onClick={handleConfirm}
        disabled={!isImageReadyToUpload}
        sx={classes.primaryButton}
      >
        {t('customSpotsEditor.loadToWorld')}
      </Button>
      <Button
        variant="outlined"
        onClick={handleLoadAnother}
        disabled={isBusy}
        sx={classes.secondaryButton}
      >
        {t('customSpotsEditor.loadAnother')}
      </Button>
      <Button
        variant="outlined"
        onClick={handleClose}
        disabled={isBusy}
        sx={classes.tertiaryButton}
      >
        {t('common.cancel')}
      </Button>
    </Box>
  );
};
